const LoadingView = ({}) => (
    "Loading..."
);

export default LoadingView;